var map = {
	"./AnnualGen.vue": [
		"a891",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-325d52b2"
	],
	"./AnnualScore.vue": [
		"55f9",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-f61bbb90"
	],
	"./Dashboard.vue": [
		"e2b0",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-90822958"
	],
	"./MajorAdminAnnualScore.vue": [
		"e056",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-7ef9d28e",
		"chunk-a97b1978",
		"chunk-3005afd2",
		"chunk-65e4d47a",
		"chunk-6e454152"
	],
	"./MajorAdminManageLecturer.vue": [
		"0769",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-2d0b3a27",
		"chunk-6499a187",
		"chunk-4c3e8416",
		"chunk-bfc84be6",
		"chunk-db397138",
		"chunk-cd74ef28"
	],
	"./MajorAdminManageStudent.vue": [
		"858f",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-2d0b3a27",
		"chunk-d6f7cff8",
		"chunk-b5b9c604",
		"chunk-5aed021f",
		"chunk-45e48838",
		"chunk-6f570d42"
	],
	"./MajorAdminTranscript.vue": [
		"df67",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-22a1dac9"
	],
	"./ManageAcademicYear.vue": [
		"263a",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-a17e34b6",
		"chunk-36897888",
		"chunk-44fb04db",
		"chunk-1f6cf470",
		"chunk-9df4401e"
	],
	"./ManageMajorGen.vue": [
		"61d4",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-2fa97426",
		"chunk-4ecac509",
		"chunk-ea521510"
	],
	"./ManageScUser.vue": [
		"ec5b",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-367bb070",
		"chunk-8157dcc6",
		"chunk-74aefea6",
		"chunk-1f6cf470",
		"chunk-7db056ca"
	],
	"./ManageScore.vue": [
		"a277",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-56073174"
	],
	"./ManageSession.vue": [
		"3869",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-78501ac3",
		"chunk-4a872bd6",
		"chunk-1ecf5a08",
		"chunk-45e48838",
		"chunk-1f11a24b"
	],
	"./ManageSessionScore.vue": [
		"ed7d",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-7ef9d28e",
		"chunk-a97b1978",
		"chunk-3005afd2",
		"chunk-65e4d47a",
		"chunk-e7320b2e"
	],
	"./ManageSubject.vue": [
		"2168",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-324e473e",
		"chunk-77f2c24d",
		"chunk-74aefea6",
		"chunk-2d184844",
		"chunk-4173d0de"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f273";
module.exports = webpackAsyncContext;